<template>
  <v-container>
    <v-row>
      <v-col cols="9">
        <UpdateContractsRadios
          requestType="CHANGE_RESERVED_CAPACITY"
        />
        <v-skeleton-loader
          :loading="collectionPointLoading"
          :types="skeleton"
          type="article"
          class="mb-6"
          height="266"
        >
          <CollectionPointHeaderCard
            title="Změna rezervované kapacity"
            detailType="changeOfReservedCapacity"
            :data="collectionPoint"
          />
        </v-skeleton-loader>

        <v-card class="elevation-12">
          <v-card-text class="px-9">
            <ReservedCapacityForm
              :collectionPoint="collectionPoint"
              :edit="true"
            />
          </v-card-text>
        </v-card>
      </v-col>

      <CollectionPointRightSideCards
        :collectionPoint="collectionPoint"
        @searchInstallation="searchInstallation"
        @installationLoading="collectionPointLoading = $event"
        :eanErrorMessage="eanErrorMessage"
        :collectionPointLoading="collectionPointLoading"
        routeType="changeOfReservedCapacity"
      />
    </v-row>
  </v-container>
</template>

<script>
import CollectionPointHeaderCard from '@/components/CollectionPointHeaderCard.vue';
import ReservedCapacityForm from '@/components/ReservedCapacityForm.vue';
import { installationMixin } from '@/components/mixins/installationMixin';
import CollectionPointRightSideCards from '@/components/utils/CollectionPointRightSideCards.vue';
import UpdateContractsRadios from '@/components/UpdateContractsRadios.vue';

export default {
  name: 'ChangeOfReservedCapacityDetail',
  mixins: [installationMixin],
  components: {
    CollectionPointHeaderCard,
    ReservedCapacityForm,
    CollectionPointRightSideCards,
    UpdateContractsRadios,
  },
  created() {
    this.loadInstallation().then((response) => {
      this.redirectByVoltageLevel(response.data, 'NN');
    });
  },
};
</script>
